import { useFetcher } from '@remix-run/react';
import { useEffect } from 'react';

const useAuthors = () => {
  const fetcher: any = useFetcher();

  useEffect(() => {
    fetcher.load('/authors?index');
  }, []);

  return {
    isLoading: !fetcher?.data,
    authors: fetcher?.data?.authors?.authors,
  };
};

export default useAuthors;
